module.exports = "./img/285b6d89b8e99b092f3397666193870a.jpg";